/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-no-literals */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
/* eslint-disable padding-line-between-statements */
import { useModal } from '@jutro/components';
import { InputField } from '@jutro/legacy/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useTranslator } from '@jutro/locale';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import {
    ViewModelForm,
    ViewModelServiceContext,
    withViewModelService,
} from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import appConfig from 'app-config';
import { WizardPageTemplate } from 'gw-portals-wizard-components-ui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import GatewayFNOLService from "twia-capability-gateway-fnol/services/GatewayFNOLService";
import messages from '../../FNOL.messages';
import AddNotePopup from './AddNotePopup';
import AdjusterContent from './Component/AdjusterContent';
import { CustomInputField } from './Component/CustomInputField/CustomInputField';
import metadata from './SummaryPage.metadata.json5';
import summaryStyles from './SummaryPage.module.scss';

function FNOLSummaryPage(props) {
    const { showModal, showAlert } = useModal();

    const translator = useTranslator();
    const { FNOLService } = useDependencies('FNOLService');
    const { ClaimService } = useDependencies('ClaimService');
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        wizardData: claimVM,
        updateWizardData,
        authHeader,
        authUserData,
        history,
        history: {
            location: { state },
        },
    } = props;
    // US26941 As part of User story added isTWIA check for Send Messaage Label changes
    const isTWIA = _.get(authUserData, 'associationName_TWIA') === 'twia';
    const isProducer = _.get(authUserData, 'userType') === 'producer';
    const { capabilitiesConfig } = appConfig;
    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [popupNotesVM, updatePopupNotesVM] = useState(null);
    const policyTypelist = viewModelService.productMetadata.get('cc').types.getTypelist('PolicyType')
    const policyType = _.get(claimVM, 'policy.policyType.value');
    const commercialPolicyType = policyTypelist.getFilter('PolicyTypes_TWIAPC9Commercial').codes.find(code => code.code === policyType);
    const isCommercial = !_.isUndefined(commercialPolicyType);
    const [lossDamageTableData, setLossDamageTableData] = useState([]);
    const [associatedContacts, setAssociateContacts] = useState([]);
    const ROLES_TO_FILTER = ['friendneighborExt', "propertyaccessExt", "propertymanagerExt", "relativeExt", 'witness'];
    const isPhoneOrTablet = breakpoint === 'phoneWide' || breakpoint === 'phone' || breakpoint === "tablet";    
    
    const newNoteViewModelObj = initialData => {
        return {
            note: viewModelService.create(
                initialData.note,
                'cc',
                'edge.capabilities.note.dto.NoteDTO'
            ),
        };
    };

    const getPrimaryPhone = (contact) => {
        switch (contact.primaryPhoneType) {
            case 'home':
                return contact.homeNumber;
            case 'work':
                return contact.workNumber;
            case 'mobile':
                return contact.cellNumber;
            default:
                return null;
        }
    }

    // US26368
    const getRelatedContacts = () => {
        let associatedContacts_TFPA = []
        if (_.get(claimVM, 'mainContact.value')) {
            const mainContact = {};

            mainContact.tempID = claimVM.mainContact.value.tempID;
            mainContact.publicID = claimVM.mainContact.value.publicID;
            mainContact.name = claimVM.mainContact.displayName.value || `${claimVM.mainContact.value.firstName} ${claimVM.mainContact.value.lastName}`;
            mainContact.relationToClaim = 'maincontact';
            mainContact.phoneNumber = getPrimaryPhone(claimVM.mainContact.value);
            mainContact.emailAddress1 = claimVM.mainContact.value.emailAddress1;
            associatedContacts_TFPA.push(mainContact);
        }

        if (claimVM.relatedContacts.value.length > 0) {
            claimVM.relatedContacts.value.forEach((contact) => {
                const relContact = {};

                relContact.tempID = contact.contact.tempID;
                relContact.publicID = contact.contact.publicID;
                relContact.name = contact.contact.displayName || `${contact.contact.firstName} ${contact.contact.lastName}`;
                relContact.relationToClaim = contact.role;
                relContact.phoneNumber = contact.contact.homeNumber;
                relContact.emailAddress1 = contact.contact.emailAddress1;
                associatedContacts_TFPA.push(relContact);
            });
        }

        if (_.get(claimVM, 'insureds_TFPA.value').length > 0) {
            claimVM.insureds_TFPA.value.forEach((contact) => {
                const insured = {};

                insured.tempID = contact.tempID;
                insured.publicID = contact.publicID;
                insured.name = contact.displayName || `${contact.firstName} ${contact.lastName}`;
                insured.relationToClaim = 'insured';
                insured.phoneNumber = getPrimaryPhone(contact);
                insured.emailAddress1 = contact.emailAddress1;
                associatedContacts_TFPA.push(insured);
            });
        }

        if (_.get(claimVM, 'agent_TFPA.value')) {
            const agent = {};

            agent.tempID = claimVM.agent_TFPA.value.tempID;
            agent.publicID = claimVM.agent_TFPA.value.publicID;
            agent.name = claimVM.agent_TFPA.displayName.value;
            agent.relationToClaim = 'agent';
            agent.phoneNumber = getPrimaryPhone(claimVM.agent_TFPA.value);
            agent.emailAddress1 = claimVM.agent_TFPA.value.emailAddress1;
            associatedContacts_TFPA.push(agent);
        }

        associatedContacts_TFPA = reduceContacts(associatedContacts_TFPA);

        return associatedContacts_TFPA
    };

    const reduceContacts = (associatedContacts_TFPA) => {
        return _.reduce(associatedContacts_TFPA, (acc, cur) => {
            let val = {};
            let hasPublicID = {};
            let hasTempID = {};

            if (cur.publicID) {
                hasPublicID = true;
            } else {
                hasPublicID = false;
            }

            if (cur.tempID) {
                hasTempID = true;
            } else {
                hasTempID = false;
            }

            val = _.find(acc, { publicID: cur.publicID }) || _.find(acc, { tempID: cur.tempID });

            if (val && hasPublicID && val.publicID === cur.publicID) {
                // update val
                val.relationToClaim = `${val.relationToClaim},${cur.relationToClaim}`;
            } else if (val && hasTempID && val.tempID === cur.tempID) {
                // update val
                val.relationToClaim = `${val.relationToClaim},${cur.relationToClaim}`;
            } else {
                acc.push(cur);
            }

            return acc;
        }, []);
    };

    const getWhereLocation = useCallback(() => {
        if (
            !_.isEmpty(claimVM.lossLocation.value) &&
            claimVM.lossLocation.city.value &&
            claimVM.lossLocation.state.value.code &&
            claimVM.lossLocation.postalCode.value
        ) {
            return `${claimVM.lossLocation.addressLine1.value}, ${claimVM.lossLocation.city.value}, ${claimVM.lossLocation.state.value.code} ${claimVM.lossLocation.postalCode.value}`;
        } // DE17537

        return '';
    }, [claimVM]);

    const getContactPerson = useCallback(() => {
        let phoneType;
        switch (claimVM.value.mainContact.primaryPhoneType) {
            case 'home':
                phoneType = claimVM.value.mainContact.homeNumber;
                break;
            case 'work':
                phoneType = claimVM.value.mainContact.workNumber;
                break;
            case 'mobile':
                phoneType = claimVM.value.mainContact.cellNumber;
                break;
            default:
                phoneType = '';
        }
        if (claimVM.value.mainContact.displayName && phoneType) {
            return `${claimVM.value.mainContact.displayName}, ${phoneType}`;
        }
        if (claimVM.value.mainContact.displayName) {
            return claimVM.value.mainContact.displayName;
        }
        return '';
    }, [claimVM]);

    const isVendorRepairOptionEnabled = useMemo(() => {
        const lossCause = _.get(claimVM.value, 'lossCause');
        return (
            !_.isNil(_.get(claimVM.value, 'lobs.personalAuto')) &&
            lossCause !== 'theftentire' &&
            isCapabilityEnabled({
                capabilitiesConfig,
                capabilityName: 'vendor',
            })
        );
    }, [capabilitiesConfig, claimVM]);

    const repairFacilityVisible = useCallback(() => {
        return (
            isVendorRepairOptionEnabled &&
            !_.isNil(_.get(claimVM.value, 'lobs.personalAuto.repairOption'))
        );
    }, [claimVM, isVendorRepairOptionEnabled]);

    const getRepairFacility = useCallback(() => {
        const repairOptionChoice = _.get(
            claimVM.value,
            'lobs.personalAuto.repairOption.repairOptionChoice'
        );
        if (!_.isNil(repairOptionChoice) && repairOptionChoice === 'NoRepair') {
            return translator(messages.fnolNoRepairRequested);
        }
        const repairFacility = _.get(
            claimVM.value,
            'lobs.personalAuto.repairOption.repairFacility'
        );
        if (_.isNil(repairFacility)) {
            return null;
        }
        const vendorName = repairFacility.contactName
            ? repairFacility.contactName
            : '';
        const vendorAddress = repairFacility.primaryAddress;
        const addressDetails = {
            addressLine1: vendorAddress.addressLine1,
            addressLine2: vendorAddress.addressLine2,
            addressLine3: vendorAddress.addressLine3,
            city: vendorAddress.city,
            state: vendorAddress.state,
            postalCode: vendorAddress.postalCode,
        };

        const formattedVendorAddress = Object.values(addressDetails)
            .filter(data => data)
            .join(', ');
        return (
            <div>
                <p>{vendorName}</p>
                <p>{formattedVendorAddress}</p>
            </div>
        );
    }, [claimVM, translator]);

    const initializeNotesVM = async () => {
        const response = await ClaimService.getClaimNotes(_.get(claimVM.value, 'claimNumber'), authHeader);
        if (response?.length) {
            _.set(claimVM, 'adjusterNote.value', response[0]);
            updateWizardData(claimVM);
        }
        if (!_.isEmpty(claimVM.adjusterNote.value)) {
            const getNotesVM = newNoteViewModelObj({
                note: {
                    claimNumber: claimVM.claimNumber.value,
                    subject: claimVM.adjusterNote.subject.value,
                    body: claimVM.adjusterNote.body.value,
                },
            });
            return updatePopupNotesVM(getNotesVM.note);
        }

        const getNotesVM = newNoteViewModelObj({
            note: {
                claimNumber: claimVM.claimNumber.value,
                subject: '',
                body: '',
            },
        });
        return updatePopupNotesVM(getNotesVM.note);
    };

    useEffect(() => {
        initializeNotesVM();
        const relatedContats = getRelatedContacts();
        const formattedRelatedContacts = relatedContats.map((contact) => {
            let { phoneNumber } = contact
            if(phoneNumber){
                phoneNumber = phoneNumber.replaceAll("-", "").replace("(", "").replace(")", "")
                const formattedPhoneNumber = phoneNumber.length === 10 ? `(${phoneNumber .substring(0,3)})-${phoneNumber .substring(3,6)}-${phoneNumber .substring(6,10)}` : phoneNumber
                contact.phoneNumber = formattedPhoneNumber;
            }
            
            return contact;
        })
        setAssociateContacts(formattedRelatedContacts);

        // US26965
        if (isCommercial) {
            const claimNumber = claimVM.claimNumber.value;
            GatewayFNOLService.getLocationBasedRUs(
                claimNumber, true, authHeader
            )
            tableLossDamageData()
        }
    }, []);

    const displayModal = useCallback(
        async (getNotesVM, isAddNoteButtonClicked) => {
            const componentProps = {
                title: isTWIA ? translator(messages.dialogAddNoteToAdjuster) : translator(messages.dialogAddNoteToAdjusterTFPA),
                actionBtnLabel: messages.dialogOk,
                cancelBtnLabel: messages.dialogCancel,
                notesVM: getNotesVM,
                updatePopupNotesVM,
                isAddNoteClicked: isAddNoteButtonClicked,
                claimVM,
                updateWizardData,
                viewModelService,
            };

            const results = await showModal(
                <AddNotePopup {...componentProps} />
            );

            return results;
        },
        [showModal, translator, viewModelService]
    );

    const updateNoteData = useCallback(
        noteVM => {
            setIsLoading(true);
            const claimNumber = _.get(claimVM.value, 'claimNumber');
            return ClaimService.updateClaimNote(
                claimNumber,
                noteVM.value,
                authHeader
            )
                .then(response => {
                    _.set(claimVM, 'adjusterNote.value', response);
                    updateWizardData(claimVM);
                    _.set(noteVM, 'value', response);
                    updatePopupNotesVM(noteVM);
                })
                .catch(() => {
                    showAlert({
                        title: messages.fnolNoteErrorHead,
                        message: messages.fnolNoteErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    }).catch(_.noop);
                    return false;
                })
                .finally(() => {
                    setIsLoading(false);
                });
        },
        [claimVM, ClaimService, authHeader, updateWizardData, showAlert]
    );

    const handleEditNote = useCallback(() => {
        displayModal(popupNotesVM, false)
            .then(updatedVM => {
                const modifiedVM = viewModelService.clone(updatedVM);
                updateNoteData(modifiedVM);
            })
            .catch(_.noop);
    }, [popupNotesVM, displayModal, updateNoteData, viewModelService]);

    const handleDeleteNote = useCallback(() => {
        setIsLoading(true);
        const claimNumber = _.get(claimVM.value, 'claimNumber');
        const noteId = _.get(claimVM.value, 'adjusterNote.publicID');
        return ClaimService.deleteClaimNote(claimNumber, noteId, authHeader)
            .then(response => {
                _.set(claimVM, 'adjusterNote.value', response);
                updateWizardData(claimVM);
                _.set(popupNotesVM, 'value', response);
                updatePopupNotesVM(popupNotesVM);
            })
            .catch(() => {
                showAlert({
                    title: messages.fnolNoteErrorHead,
                    message: messages.fnolNoteErrorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                }).catch(_.noop);
                return false;
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [
        claimVM,
        ClaimService,
        authHeader,
        updateWizardData,
        popupNotesVM,
        showAlert,
    ]);

    const saveNoteData = useCallback(
        noteVM => {
            setIsLoading(true);
            const claimNumber = _.get(claimVM.value, 'claimNumber');
            return ClaimService.createClaimNote(
                claimNumber,
                noteVM.value,
                isProducer,
                authHeader
            )
                .then(response => {
                    _.set(claimVM, 'adjusterNote.value', response);
                    updateWizardData(claimVM);
                    _.set(noteVM, 'value', response);
                    updatePopupNotesVM(noteVM);
                })
                .catch(() => {
                    showAlert({
                        title: messages.fnolNoteErrorHead,
                        message: messages.fnolNoteErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    }).catch(_.noop);
                    return false;
                })
                .finally(() => {
                    setIsLoading(false);
                });
        },
        [claimVM, ClaimService, authHeader, updateWizardData, showAlert]
    );

    const addNotesToAdjuster = useCallback(() => {
        displayModal(popupNotesVM, true)
            .then(updatedVM => {
                const modifiedVM = viewModelService.clone(updatedVM);
                saveNoteData(modifiedVM);
            })
            .catch(_.noop);
    }, [popupNotesVM, saveNoteData, displayModal, viewModelService]);

    const filteredRoleTypeList = useMemo(() => {
        const typeList = viewModelService.create(
            {},
            'cc',
            'edge.capabilities.claim.fnol.dto.FnolRelatedContactDTO'
        );
        const filteredList = typeList.role.aspects.availableValues
            .map(typeCode => ({
                code: typeCode.code,
                name: translator({
                    id: typeCode.name,
                    defaultMessage: typeCode.name,
                }),
            }))
            .sort((a, b) => a.name.localeCompare(b.name));


        return filteredList
    }, [ROLES_TO_FILTER, translator, viewModelService]);



    const getPhoneNumberCell = (rowData) => {
         return (
            <InputField
                id="phone-field"
                showLabel={false}
                readOnly
                value={rowData.phoneNumber}
            />
        )
    }

    // DE16762
    const getRoleInUppercase = useCallback((value) => {
        const roles = value.relationToClaim.split(",");

        return roles.map((role) => {
            const roleItem = _.find(filteredRoleTypeList, (rd) => rd.code === role)
            return roleItem ? roleItem.name : role.charAt(0).toUpperCase() + role.slice(1)
        }).join(",")

    }, [filteredRoleTypeList])

    // DE16709
    const editClaimReportText = useCallback(() => (
        <div>
            <div className={summaryStyles.claimReportHeader}>{translator(messages.editClaimReportHeader)}</div>
            <span>1. {translator(messages.editClaimReportPrevious)}</span><br />
            <span>2. {translator(messages.editClaimReportSideMenu)}</span>
        </div>
    ), [translator])

    // DE16710
    const tableLossDamageData = useCallback(() => {
        const lossDamage = _.get(claimVM, 'lossDamagesExt.value')

        const lossDamageData = []

        if (!_.isUndefined(lossDamage)) {
            if (lossDamage.length !== 0) {
                lossDamage.forEach(element => {
                    lossDamageData.push(element.locationBasedRU)
                });
                setLossDamageTableData(lossDamageData);
            }

        }
    },
        [claimVM]
    );

    const onNext = useCallback(() => {
        const waterDamageSelected = ['waterdamage'].includes(_.get(claimVM.value, 'lossCause'));
        setIsLoading(true);
        setLoadingMessage(translator(messages.fnolSubmitClaimDetails));
        const request = _.clone(claimVM.value);
        request.documents = [];
        request.contacts = [];
        request.policy = null;
        if (waterDamageSelected) {
            _.set(request, 'lobs.homeowners.propTheftVanDamageDTO_TFPA', undefined);
            _.set(request, 'lobs.homeowners.propertyFireDamage', undefined);
        }

        return FNOLService.submitClaim(request, authHeader)
            .then(response => {
                claimVM.value = response;
                const claimNumber = _.get(claimVM.value, 'claimNumber');
                const { redirectPath } = state;

                return history.push({
                    pathname: `/confirmation/${claimNumber}`,
                    state: {
                        redirectPath,
                    },
                });
            })
            .catch(() => {
                showAlert({
                    title: messages.fnolErrorSubmitClaimTitle,
                    message: messages.fnolErrorSubmitClaimMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                }).catch(_.noop);

                return false;
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [
        translator,
        FNOLService,
        claimVM,
        authHeader,
        state,
        history,
        showAlert,
    ]);

    const typeOfIncident = _.get(claimVM, 'lossCause.value.name');

    const getLossLocation = () => {

        if (claimVM.lossLocation.value && claimVM.lossLocation.value.displayName) {
            return claimVM.lossLocation.value.displayName
        }

        return getWhereLocation()
    }

    const generateAssociatedContactsOverrides = () => {
        const overrides = associatedContacts.map((item, index) => ({
            [`associatedName${index}`]: {
                value: item.name,
            },
            [`associatedPrimaryPhone${index}`]: {
                value: item.phoneNumber,
            },
            [`associatedRole${index}`]: {
                value: getRoleInUppercase({ relationToClaim: item.relationToClaim }),
            },
            [`associatedEmail${index}`]: {
                value: item.emailAddress1,
            },
        }));
        return Object.assign({}, ...overrides);
    };

    const overrides = {
        '@field': {
            phoneWide: {
                labelPosition: 'top',
            },
        },
        fnolTypeOfIncident: {
            label: translator(messages.whathappened),
            value: _.get(claimVM, 'description.value')
        },
        addNotebtnDiv: {
            visible: _.isEmpty(claimVM.adjusterNote.value),
        },
        fnolHeader: {
            content: isTWIA ? translator(messages.fnolAddNoteToAdjuster) : translator(messages.fnolAddNoteToAdjusterTFPA),
            visible: appConfig.persona === 'producer'
        },
        // DE16718
        adjusterNoteField: {
            label: isTWIA ? translator(messages.fnolNoteToAdjuter) : translator(messages.fnolNoteToAdjuterTFPA),
            visible: !_.isUndefined(claimVM.adjusterNote.value) && !_.isEmpty(claimVM.adjusterNote.value)
        },
        fraudStatement: {
            content: isTWIA ? translator(messages.fnolSummaryPara) : translator(messages.fnolSummaryParaTFPA),
        },
        addNoteAdjuster: {
            content: isTWIA ? translator(messages.fnolAddNoteToAdjuster) : translator(messages.fnolAddNoteToAdjusterTFPA),
        },
        addNoteAdjusterMsg: {
            content: isTWIA ? translator(messages.fnolNoteToAdjuter) : translator(messages.fnolNoteToAdjuterTFPA),
        },
        fnolWhen: {
            phoneWideTime: {
                labelPosition: 'top',
            },
        },
        fnolContactPerson: {
            value: getContactPerson(),
        },
        summaryPageLoader: {
            loaded: !isLoading,
            loadingMessage: translator(loadingMessage),
        },
        fnolSummaryPage: {
            visible: !isLoading,
        },
        fnolRepairFacility: {
            visible: repairFacilityVisible(),
            value: repairFacilityVisible() ? getRepairFacility() : '',
        },
        adjusterContent: {
            handleEditNote,
            handleDeleteNote,
            claimVM,
        },
        reviewInformationPara: {
            content: translator(messages.reviewInfoText)
        },
        finalStepText: {
            content: isTWIA ? translator(messages.finalStepPara) : translator(messages.finalStepParaTFPA)
        },
        editClaimReportText: {
            content: editClaimReportText()
        },
        lossCause: {
            value: translator({
                id: typeOfIncident,
                defaultMessage: typeOfIncident,
            }),
            label: translator(messages.fnolCauseofDamageorloss)
        },
        priInsLocation: {
            visible: !isCommercial,
            label: translator(messages.fnolSummaryWhere),
            value: getLossLocation()
        },
        detailedScheduleTable: {
            data: associatedContacts,
            visible: !isPhoneOrTablet
        },
        // DE16710
        userRolesTable: {
            data: lossDamageTableData

        },
        whereGridDiv: {
            visible: isCommercial
        },
        detailedScheduleTableMobile: {
            data: associatedContacts,
            visible: isPhoneOrTablet
        },
        ...(isPhoneOrTablet && generateAssociatedContactsOverrides())
    };
    const resolvers = {
        resolveCallbackMap: {
            addNotesToAdjuster,
            getRoleInUppercase,
            getPhoneNumberCell
        },
        resolveComponentMap: {
            adjusterfield: CustomInputField,
            adjustercontent: AdjusterContent,
        },
        resolveClassNameMap: summaryStyles,
    };

    const readValue = (id, path) => {
        return readViewModelValue(
            metadata.pageContent,
            claimVM,
            id,
            path,
            overrides
        );
    };
    return (
        <WizardPage
            nextLabel={translator(messages.fnolSubmitClaim)}
            // cancelLabel={translator(messages.fnolSaveandExit)}
            onNext={onNext}
            template={WizardPageTemplate}
            showCancel={isLoading ? false : true}
            showNext={isLoading ? false : true}
            showPrevious={isLoading ? false : true}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

FNOLSummaryPage.propTypes = wizardProps;
FNOLSummaryPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
};
export default withRouter(
    withAuthenticationContext(withViewModelService(FNOLSummaryPage))
);
